import { Head, Banner } from "../components/Project";
import { Grid, Space, Table } from "../components/Layout";
import { Title, Texts, Media, Button } from "../components/Object";
import { useState, useMemo } from "react";

const Contact = () => {
  const formId = 80;
  const API_URL = `${tmp_path.site_url}/wp-json/contact-form-7/v1/contact-forms/${formId}/feedback`;

  const [message, setMessage] = useState();
  const [error, setError] = useState([]);
  const [status, setStatus] = useState("validation_failed");
  const [values, setValues] = useState({
    subject: "",
    "your-name": "",
    "your-furi": "",
    "your-mail": "",
    "your-address": "",
    "your-number": "",
    body: "",
  });

  const handleSubmit = async (event) => {
    event.preventDefault();
    const formElement = event.target;
    const body = new FormData(formElement);
    fetch(API_URL, {
      method: "POST",
      body,
    })
      .then((res) => res.json())
      .then((res) => {
        setMessage(res.message);
        setStatus(res.status);
        if (res.invalid_fields) {
          setError(res.invalid_fields);
        }
        scroll({
          top: 0,
          left: 0,
          behavior: "smooth",
        });
      })
      .catch((error) => {
        console.error("通信に失敗しました", error);
      });
  };


  const Input = (props) => {
    const inputElm = {
      text: function text(name) {
        return (
          <input
            className="c-input"
            type="text"
            placeholder=""
            name={name}
            onChange={(e) => {
              setValues((state) => ({ ...state, [name]: e.target.value }));
            }}
          />
        );
      },
      textarea: function textarea(name) {
        return <textarea className="c-input" name={name}></textarea>;
      },
      radio: function radio(name, value) {
        let Items = value.map((item, value) => {
          return (
            <>
              <label className="c-input__radio--wrap">
                <input
                  className="c-input c-input__radio"
                  name={name}
                  type="radio"
                  value={item}
                ></input>
                <p className="p-text__bold">{item}</p>
              </label>
            </>
          );
        });
        return (
          <div className="p-grid__column--repeat--2 p-grid__gap--16">
            {Items}
          </div>
        );
      },
    };
    return (
      <div className="p-form__items">
        <label className="c-text__bold">{props.label}</label>
        {inputElm[props.elm](props.name, props.value)}
      </div>
    );
  };

  const DefaultElm = () => {
    return (
      <>
        <form
          action="/nagao/contact/#wpcf7-f77-o3"
          onSubmit={(e) => handleSubmit(e)}
        >
          <div className="p-form__wrap">
            <input type="hidden" name="_wpcf7" value={formId} />
            <input
              type="hidden"
              name="_wpcf7_unit_tag"
              value={`wpcf7-f${formId}-o1`}
            />
            <input type="hidden" name="_wpcf7_locale" value="ja" />
            <Input
              name="subject"
              label="お問い合わせ種別"
              elm="radio"
              value={["施工依頼", "求人応募", "その他"]}
            />
            <Input name="your-name" label="お名前" elm="text" />
            <Input name="your-furi" label="ふりがな" elm="text" />
            <Input name="your-mail" label="メールアドレス" elm="text" />
            <Input name="your-number" label="電話番号" elm="text" />
            <Input name="your-address" label="住所" elm="text" />
            <Input name="body" label="お問い合わせ内容" elm="textarea" />
            {message && (
              <div className="p-form__message">
                <p className="c-text__med c-text--bold">{message}</p>
              </div>
            )}
          </div>
          <div className="u-margin--64">
            <button
              className="c-button p-form__submit"
              type="submit"
              data-state="center"
            >
              <div className="c-text__wrap--text">
                <div className="c-button__img--arrow" />
                <Texts slug={"button/submit"} />
              </div>
            </button>
          </div>
        </form>
      </>
    );
  };

  const DefaultElmMemo = useMemo(() => {
    return <DefaultElm></DefaultElm>;
  }, [status]);

  const BodyElm = () => {
    if (status == "mail_sent") {
      return (
        <>
          <Texts slug="contact/fin" class="c-text--center"></Texts>
          <div className="u-margin--64">
            <Button link="/" slug="returntop" type="center"></Button>
          </div>
        </>
      );
    } else {
      return <>{DefaultElmMemo}</>;
    }
  };

  const BodyElmMemo = useMemo(() => {
    return <BodyElm></BodyElm>;
  }, [status]);

  return (
    <>
      <Head slug="contact"></Head>
      {message && (
        <div className="p-form__message p-form__message--fix">
          <p className="c-text__med c-text--bold">{message}</p>
        </div>
      )}
      <div className="p-post__wrap">
        <Space size={["0 0 120px", "0 0 80px"]}>
          <div className="l-row">
            <div className="p-post__wrap--inner">{BodyElmMemo}</div>
          </div>
        </Space>
      </div>
    </>
  );
};

export default Contact;
